import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExportDropdown = ({ onExport, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const exportOptions = [
    {
      id: 'csv',
      label: 'Export as CSV',
      icon: 'FileSpreadsheet',
      description: 'Comma-separated values file',
      format: 'CSV'
    },
    {
      id: 'excel',
      label: 'Export as Excel',
      icon: 'FileSpreadsheet',
      description: 'Microsoft Excel workbook',
      format: 'XLSX'
    },
    {
      id: 'pdf',
      label: 'Export as PDF',
      icon: 'FileText',
      description: 'Portable document format',
      format: 'PDF'
    },
    {
      id: 'json',
      label: 'Export as JSON',
      icon: 'Code',
      description: 'JavaScript object notation',
      format: 'JSON'
    }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleExportClick = (option) => {
    onExport(option?.id, option?.format);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <Button
        variant="outline"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
        iconName="Download"
        iconPosition="left"
        iconSize={16}
      >
        Export
      </Button>
      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-64 bg-popover border border-border rounded-lg shadow-elevation-modal z-50">
          <div className="p-3 border-b border-border">
            <h3 className="font-medium text-popover-foreground">
              Export Candidates
            </h3>
            <p className="text-sm text-muted-foreground">
              Choose your preferred format
            </p>
          </div>
          
          <div className="py-2">
            {exportOptions?.map((option) => (
              <button
                key={option?.id}
                onClick={() => handleExportClick(option)}
                className="w-full flex items-center space-x-3 px-3 py-3 text-left hover:bg-muted transition-colors"
              >
                <Icon 
                  name={option?.icon} 
                  size={18} 
                  className="text-primary flex-shrink-0"
                />
                <div className="flex-1">
                  <div className="font-medium text-popover-foreground">
                    {option?.label}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {option?.description}
                  </div>
                </div>
                <span className="text-xs text-muted-foreground font-mono">
                  {option?.format}
                </span>
              </button>
            ))}
          </div>

          <div className="p-3 border-t border-border bg-muted/30">
            <div className="flex items-center text-xs text-muted-foreground">
              <Icon name="Info" size={12} className="mr-1" />
              <span>Export includes filtered results only</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;